/* ----------------------------------------------------------------------------------------------------------------------
   REFORMER LAB — EVENTS
   ----------------------------------------------------------------------------------------------------------------------
   Small behaviours for the events feed and the event product page. No dependencies.
     1. Session picker on the event page: the chosen studio / date row drives the hidden variant id, the Book button,
        the price, the spots-left note and the waitlist session field.
     2. Add-to-calendar links (Google + .ics) built from the event's date / time / location.
     3. Studio filter chips on the events feed (client side; re-spotlights the first visible card).
   ---------------------------------------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function enc(s) { return encodeURIComponent(s || ''); }
  function icsEscape(s) {
    return String(s || '').replace(/\\/g, '\\\\').replace(/;/g, '\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');
  }
  function addDays(iso, days) {
    var p = iso.split('-').map(Number);
    var d = new Date(Date.UTC(p[0], p[1] - 1, p[2] + days));
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate());
  }
  function compact(iso) { return iso.replace(/-/g, ''); }
  function stamp(iso, hm) { return compact(iso) + 'T' + pad(hm[0]) + pad(hm[1]) + '00'; }

  /* "6:30 – 8:30pm", "7pm", "10am - 12pm", "19:00-20:30" -> { start: [h, m], end: [h, m] | null } or null */
  function parseTimeRange(text) {
    if (!text) return null;
    var re = /(\d{1,2})(?::(\d{2}))?\s*(am|pm|a\.m\.|p\.m\.)?/gi;
    var tokens = [];
    var m;
    while ((m = re.exec(text)) && tokens.length < 2) {
      var h = parseInt(m[1], 10);
      var min = m[2] ? parseInt(m[2], 10) : 0;
      if (h > 24 || min > 59) continue;
      var mer = m[3] ? m[3].replace(/\./g, '').toLowerCase() : null;
      tokens.push({ h: h, m: min, mer: mer });
    }
    if (!tokens.length) return null;
    var start = tokens[0];
    var end = tokens[1] || null;
    /* "7:00 – 8:15pm": the start borrows the end's meridiem, flipping to am if that would put it after the end. */
    if (!start.mer && end && end.mer) {
      start.mer = end.mer;
      if (to24(start) > to24(end)) start.mer = start.mer === 'pm' ? 'am' : 'pm';
    }
    if (end && !end.mer && start.mer) {
      end.mer = start.mer;
      if (to24(end) < to24(start)) end.mer = end.mer === 'am' ? 'pm' : 'am';
    }
    var s = to24(start);
    var e = end ? to24(end) : null;
    if (e !== null && e <= s) e = null;
    return { start: [Math.floor(s / 60), s % 60], end: e === null ? null : [Math.floor(e / 60), e % 60] };
  }
  function to24(t) {
    var h = t.h;
    if (t.mer === 'pm' && h < 12) h += 12;
    if (t.mer === 'am' && h === 12) h = 0;
    return h * 60 + t.m;
  }

  /* ---------- 2. calendar links ---------- */
  function buildCalendar(cal, radio) {
    if (!cal) return;
    var attr = function (name) {
      var v = radio && radio.getAttribute('data-' + name);
      return v || cal.getAttribute('data-' + name) || '';
    };
    var date = attr('date');
    if (!date) { cal.hidden = true; return; }
    var endDate = attr('end-date') || date;
    var time = attr('time');
    var title = cal.getAttribute('data-title') || document.title;
    var location = attr('location');
    var url = cal.getAttribute('data-url') || window.location.href;
    var description = cal.getAttribute('data-description') || '';
    if (radio && radio.getAttribute('data-title')) title += ' — ' + radio.getAttribute('data-title');

    var range = parseTimeRange(time);
    var allDay = !range;
    var start, end;
    if (allDay) {
      start = compact(date);
      end = compact(addDays(endDate, 1));
    } else {
      var endHm = range.end || [range.start[0] + 1, range.start[1] + 30];
      if (endHm[1] >= 60) { endHm = [endHm[0] + 1, endHm[1] - 60]; }
      if (endHm[0] >= 24) { endHm = [23, 59]; }
      start = stamp(date, range.start);
      end = stamp(endDate, endHm);
    }

    var details = description + (url ? '\n\n' + url : '');
    var google = 'https://calendar.google.com/calendar/render?action=TEMPLATE'
      + '&text=' + enc(title)
      + '&dates=' + start + '/' + end
      + '&details=' + enc(details)
      + '&location=' + enc(location);

    var now = new Date();
    var dtstamp = now.getUTCFullYear() + pad(now.getUTCMonth() + 1) + pad(now.getUTCDate()) + 'T' + pad(now.getUTCHours()) + pad(now.getUTCMinutes()) + pad(now.getUTCSeconds()) + 'Z';
    var uid = compact(date) + '-' + (radio ? radio.value : 'event') + '@' + window.location.hostname;
    var ics = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Reformer Lab//Events//EN',
      'CALSCALE:GREGORIAN',
      'METHOD:PUBLISH',
      'BEGIN:VEVENT',
      'UID:' + uid,
      'DTSTAMP:' + dtstamp,
      allDay ? 'DTSTART;VALUE=DATE:' + start : 'DTSTART:' + start,
      allDay ? 'DTEND;VALUE=DATE:' + end : 'DTEND:' + end,
      'SUMMARY:' + icsEscape(title),
      'DESCRIPTION:' + icsEscape(details),
      location ? 'LOCATION:' + icsEscape(location) : '',
      url ? 'URL:' + url : '',
      'END:VEVENT',
      'END:VCALENDAR'
    ].filter(Boolean).join('\r\n');

    var g = cal.querySelector('[data-evp-cal-google]');
    var i = cal.querySelector('[data-evp-cal-ics]');
    if (g) g.href = google;
    if (i) i.href = 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
    cal.hidden = false;
  }

  /* ---------- 1. session picker ---------- */
  function initEventProduct(root) {
    var form = document.getElementById(root.getAttribute('data-evp-form'));
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var radios = Array.prototype.slice.call(root.querySelectorAll('input[type="radio"][data-evp-session]'));
    var submit = root.querySelector('[data-evp-submit]');
    var submitLabel = root.querySelector('[data-evp-submit-label]');
    var priceEl = root.querySelector('[data-evp-price]');
    var statusEl = root.querySelector('[data-evp-status]');
    var cal = root.querySelector('[data-evp-calendar]');
    var waitlist = root.querySelector('details[data-evp-waitlist]');
    var sessionFields = root.querySelectorAll('[data-evp-waitlist-session]');

    function checkedRadio() {
      for (var k = 0; k < radios.length; k++) if (radios[k].checked) return radios[k];
      return null;
    }

    function sync() {
      var r = checkedRadio();
      radios.forEach(function (radio) {
        var row = radio.closest('.eva-session');
        if (row) row.classList.toggle('is-selected', radio === r);
      });
      if (!r) { buildCalendar(cal, null); return; }

      var available = r.getAttribute('data-available') === 'true';
      if (idInput) idInput.value = r.value;
      if (submit) {
        submit.disabled = !available;
        if (submitLabel) submitLabel.textContent = submit.getAttribute(available ? 'data-label-book' : 'data-label-sold-out');
      }
      if (priceEl) priceEl.textContent = r.getAttribute('data-price') || '';
      if (statusEl) statusEl.textContent = r.getAttribute('data-status') || '';
      sessionFields.forEach(function (f) { f.value = r.getAttribute('data-title') || ''; });
      if (waitlist && !available) waitlist.open = true;
      buildCalendar(cal, r);
    }

    radios.forEach(function (radio) { radio.addEventListener('change', sync); });

    /* A waitlist form that just posted (success or error) should be open so the message is seen. */
    if (waitlist && waitlist.querySelector('.banner')) {
      waitlist.open = true;
      if (window.location.hash === '#waitlist-form' || /contact_posted/.test(window.location.search)) {
        waitlist.scrollIntoView({ block: 'center' });
      }
    }

    sync();
  }

  /* ---------- 3. studio filter ---------- */
  function initFilter(bar) {
    var feed = bar.closest('[data-evb-feed]') || bar.parentElement;
    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-studio]'));
    var lists = Array.prototype.slice.call(feed.querySelectorAll('[data-evb-list]'));
    var empty = feed.querySelector('[data-evb-filter-empty]');

    function cardStudios(card) {
      return (card.getAttribute('data-studios') || '').toLowerCase().split(/\s+/).filter(Boolean);
    }

    /* Hide chips no card can match, so we never offer an empty filter. */
    var allCards = Array.prototype.slice.call(feed.querySelectorAll('.evb-card[data-studios]'));
    chips.forEach(function (chip) {
      var value = chip.getAttribute('data-studio');
      if (!value) return;
      var any = allCards.some(function (card) { return cardStudios(card).indexOf(value) !== -1; });
      chip.hidden = !any;
    });

    function apply(value) {
      chips.forEach(function (chip) {
        var active = chip.getAttribute('data-studio') === value;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var upcomingVisible = 0;
      lists.forEach(function (list) {
        var cards = Array.prototype.slice.call(list.querySelectorAll(':scope > .evb-card'));
        var firstVisible = null;
        cards.forEach(function (card) {
          var show = !value || cardStudios(card).indexOf(value) !== -1;
          card.hidden = !show;
          if (show && !firstVisible) firstVisible = card;
        });
        if (list.classList.contains('evb-list--spotlight')) {
          cards.forEach(function (card) { card.classList.toggle('evb-card--spotlight', card === firstVisible); });
        }
        if (list.getAttribute('data-evb-list') === 'upcoming') {
          upcomingVisible = cards.filter(function (card) { return !card.hidden; }).length;
          list.hidden = upcomingVisible === 0;
        }
      });
      if (empty) empty.hidden = upcomingVisible > 0;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () { apply(chip.getAttribute('data-studio') || ''); });
    });
  }

  function init() {
    document.querySelectorAll('[data-evp]').forEach(initEventProduct);
    document.querySelectorAll('[data-evb-filter]').forEach(initFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: sections re-render on setting changes. */
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-evp]').forEach(initEventProduct);
    event.target.querySelectorAll('[data-evb-filter]').forEach(initFilter);
  });
})();
